import type { PharosMessage } from '../servicebus';
import type { TenantPurgeRequestedPayload } from '../servicebus/tenant';
import { ObjectFactory } from './object.factory';

export class TenantPurgeRequestedPayloadFactory extends ObjectFactory<TenantPurgeRequestedPayload> {
  protected getDefaults(): TenantPurgeRequestedPayload {
    return {
      backupRunId: '2026-01-01T00-00-00.000Z',
      requestedAt: '2026-01-01T00:00:00.000Z',
      requestedByUserId: 'aabbccddeeff001122334455',
      tenantId: 'aabbccddeeff001122334456',
      tenantName: 'Acme Corp',
    };
  }
}

// Pre-instantiated for convenience
export const tenantPurgeRequestedPayloadFactory = new TenantPurgeRequestedPayloadFactory();

/** Builds the `on-tenant-purge-requested` Service Bus message for `tenantId`. */
export function buildTenantPurgeSbMessage(tenantId: string): PharosMessage<TenantPurgeRequestedPayload> {
  return {
    correlationId: 'correlation-id-1',
    identifiers: { tenantId },
    payload: tenantPurgeRequestedPayloadFactory.build({ tenantId }),
  };
}
